<template>
<!--  -->
<!-- bgPrimary -->
<div class="dpIB fWhite">
	<!-- <div v-if="id=='1'" class="icoSys dvStatus bgLight fFail" :title="getLanguageStr('phrase655','通讯状态未获取')">
		<Icon name="noCommunication" />
	</div>
	<div v-if="id===null" class="icoSys dvStatus bgLight fFail" :title="getLanguageStr('phrase656','报警状态未获取')">
		<Icon name="noAlarm" />
	</div>
	 -->
	<!-- 电站状态 -->
	<div v-if="type=='plant'&&id=='NORMAL'" class="icoSys dvStatus bgSuccess" :title="$t('word1461',['通讯正常'])">
		<Icon name="shield-yes" />
	</div>
    <div v-if="type=='plant'&&id=='ALL_OFFLINE'" class="icoSys dvStatus bgWarning" :title="getLanguageStr('word1659','全部设备离线')">
		<Icon name="offline-all" />
	</div>
	<div v-if="type=='plant'&&id=='PARTIAL_OFFLINE'" class="icoSys dvStatus bgDanger" :title="getLanguageStr('word1677','部分设备离线')">
		<Icon name="offline-part" />
	</div>
	<!-- <div v-if="type=='plant'&&id=='ALERT'" class="icoSys dvStatus bgWarning" :title="$t('plant_alert59',['报警'])">
		<svg><use xlink:href="#ico-dvStatus-warning"></use></svg>
	</div> -->
    <div v-if="type=='plant'&&id=='NO_DEVICE'" class="icoSys dvStatus bgDanger" :title="$t('word1269',['接入中'])">
		<Icon name="build" />
		<!-- <svg><use xlink:href="#ico-dvStatus-build"></use></svg> -->
	</div>
	<!-- 设备状态 0：未激活 1：在线 2：报警 3：离线  -->
	<div v-if="type=='device'&&(id===0)">
		<div class="icoSys dvStatus bgNeutral" :class="{'icoSys-mini':showType=='mini'}" :title="$t('word94',['未激活'])">
			<Icon v-if="showType=='ico'" name="unon" />
		</div>
		<span v-if="showType=='mini'">{{getLanguageStr('word94','未激活')}}</span>
	</div>
	<div v-if="type=='device'&&(id==='ONLINE'||id===1)">
		<div class="icoSys dvStatus bgSuccess" :class="{'icoSys-mini':showType=='mini'}" :title="$t('word1588',['在线'])">
			<Icon v-if="showType=='ico'" name="shield-yes" />
		</div>
		<span v-if="showType=='mini'">{{getLanguageStr('word1588','在线')}}</span>
	</div>
	<div v-if="type=='device'&&(id==='ALERT'||id===2)">
		<div class="icoSys dvStatus bgWarning" :class="{'icoSys-mini':showType=='mini'}" :title="$t('plant_alert59',['报警'])">
			<Icon v-if="showType=='ico'" name="status-alarm" />
		</div>
		<span v-if="showType=='mini'">{{getLanguageStr('plant_alert59','报警')}}</span>
	</div>
	<div v-if="type=='device'&&(id==='OFFLINE'||id===3)">
		<div class="icoSys dvStatus bgWarning" :class="{'icoSys-mini':showType=='mini'}" :title="$t('word64',['离线'])">
			<Icon v-if="showType=='ico'" name="offline-all" />
		</div>
		<span v-if="showType=='mini'">{{getLanguageStr('word64','离线')}}</span>
	</div>
		<!-- 父设备状态  1：在线 2：报警 3：离线  -->
	<div v-if="type=='parDevice'&&(id==='ONLINE'||id===1)" class="icoSys dvStatus bgSuccess" :title="$t('word1588',['在线'])">
		<Icon name="shield-yes" />
	</div>
	<div v-if="type=='parDevice'&&(id==='ALERT'||id===2)" class="icoSys dvStatus bgWarning" :title="$t('plant_alert59',['报警'])">
		<Icon name="status-alarm" />
	</div>
		<div v-if="type=='parDevice'&&(id==='OFFLINE'||id===3)" class="icoSys dvStatus bgWarning" :title="$t('word64',['离线'])">
		<Icon name="offline-all" />
	</div>
	<!-- 激活状态 -->
	<div v-if="type=='activedState'&&(id==1)" class="icoSys dvStatus bgSuccess" :title="$t('word93',['已激活'])">
		<Icon name="on" />
	</div>
	<div v-if="type=='activedState'&&(id==0)" class="icoSys dvStatus bgNeutral" :title="$t('word94',['未激活'])">
		<Icon name="unon" />
	</div>
<!-- 	<div v-if="type=='device'&&id=='ALERT'" class="icoSys dvStatus bgWarning" :title="$t('plant_alert59',['报警'])">
		<svg><use xlink:href="#ico-dvStatus-warning"></use></svg>
	</div> -->

	<!-- 报警状态 -->
	<div v-if="type=='alarm'&&(id==='ALERTING'||id >=0)" class="icoSys dvStatus bgWarning" :title="$t('word1464',['有报警'])">
		<Icon name="status-alarm" />
	</div>
	<div v-if="type=='alarm'&&(id==='NORMAL'||id<0)" class="icoSys dvStatus bgSuccess" :title="$t('word1465',['无报警'])">
		<Icon name="shield-save" />
	</div>

	<!-- 设备报警状态 -1 无报警 其他：有报警 -->
	<div v-if="type=='deviceAlarm'&&(id==='ALERTING'||id >=0)" class="icoSys dvStatus bgWarning" :title="$t('word1464',['有报警'])">
		<Icon name="status-alarm" />
	</div>
	<div v-if="type=='deviceAlarm'&&(id==='NORMAL'||id<0)" class="icoSys dvStatus bgSuccess" :title="$t('word1465',['无报警'])">
		<Icon name="shield-save" />
	</div>

	<!-- 成员状态 -->
	<div v-if="type=='statusUser'&&id===1" class="icoSys dvStatus bgError" :title="$t('word94',['未激活'])">
		<Icon name="no" />
	</div>
	<div v-if="type=='statusUser'&&id===2" class="icoSys dvStatus bgSuccess" :title="$t('word93',['已激活'])">
		<Icon name="yes" />
	</div>
	<!-- $t('word167',['建设中'])
	<div v-if="type=='plant'&&id==5" class="icoSys dvStatus bgGreen" language-title="word219,入库未激活" ico="5">
		<svg><use xlink:href="#ico-dvStatus-storage"></use></svg>
	</div>
	<div v-if="type=='plant'&&id==6" class="icoSys dvStatus bgBlueLight" language-title="word220,激活未注册" ico="6">
		<svg><use xlink:href="#ico-dvStatus-activation"></use></svg>
	</div>
	 -->
</div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
export default{
  name: 'StatusIco',
  components: {},
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    type: {// 指定适配的类型
      type: String,
      default: ''
    },
    showType: {// 激活的索引项
      type:String,
      default:"ico"//ico,mini
    }
  },
  data () {
    return {}
  },
  methods: {
    getLanguageStr
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.icoSys-mini{width:.5em;height:.5em;display:inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/StatusIco.vue